import useEvent from "react-use-event-hook";
import { useSetRecoilState } from "recoil";

import {
  useEmitterListener,
  usePageContext,
  useTableListActions,
} from "@ryde/redux";
import {
  GlobalAppEventEnum,
  selectedIdsSF,
  unique,
  type IStationDto,
} from "@ryde/shared";

/**
 * A station created on this page outside its grid ("Add station here" in the map's place info) joins the
 * grid the way the grid's own add does, highlighted. It is ticked too, since the map pins only the
 * stations ticked in the grid. Listened for at page level, so the grid gets it even with the map closed.
 */
export const useStationsCreatedStations = (): void => {
  const { entity } = usePageContext();
  const { addTableDto } = useTableListActions(entity);
  const setSelectedIds = useSetRecoilState(selectedIdsSF(entity));

  const showCreatedStation = useEvent((station: IStationDto): void => {
    addTableDto({ ...station });
    setSelectedIds(prev => unique([...prev, station.id]));
  });

  useEmitterListener({
    event: GlobalAppEventEnum.STATION_CREATED,
    handler: showCreatedStation,
  });
};
